import React, { useState, useEffect, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./Properties.css";
import PropertyCard from "./PropertyCard"; // Adjust path if needed
import bgImage1 from "../header-background-images/Modern-Home.png";
import bgImage2 from "../header-background-images/Header-Background-2.jpg";
import bgImage3 from "../header-background-images/Forest-Cabin.jpg";
import bgImage4 from "../header-background-images/1001__original.webp";
import bgImage5 from "../header-background-images/Urban-Apartment-Loft.png";
import bgImage6 from "../header-background-images/Suburban-House.png";

const PropertiesData = [
  {
    title: "Modern Family Home",
    location: "Barcelona, Spain",
    description:
      "Nestled in the vibrant heart of Barcelona, this charming modern family home offers 120m² of comfortable and stylish living space. Bright, open-plan interiors flow seamlessly into a private garden, perfect for relaxing and entertaining. With three cozy bedrooms, a state-of-the-art kitchen, and close proximity to schools and local markets, everything seems to be within reach, this residence blends convenience and tranquility — the ideal setting for family life.",
    features: [
      { icon: "🏡", text: "Spacious Garden" },
      { icon: "🍳", text: "Modern Kitchen" },
      { icon: "🛏️", text: "3 Cozy Bedrooms" },
      { icon: "🚗", text: "Private Parking" },
      { icon: "🏫", text: "Close to Schools" },
    ],
    price: "550,000",
    beds: "3",
    baths: "2",
    size: "120 m²",
    status: "For Sale",
    bgImage: bgImage1,
    ctabtn: "buy now",
  },

  {
    title: "Hollywood Heights ",
    location: "Hollywood, United States",
    description:
      "Perched above the glittering skyline of Los Angeles, Hollywood Heights is a 200m² contemporary residence that blends sleek modern design with iconic city views. Floor-to-ceiling windows flood the space with natural light, showcasing panoramic sunsets over the Hollywood Hills. With four spacious bedrooms, an open-concept living area, and a rooftop terrace made for entertaining, this home captures the essence of LA luxury — glamour, privacy, and style.",
    features: [
      { icon: "🎬", text: "Home Theater" },
      { icon: "🌇", text: "City Skyline Views" },
      { icon: "🏋️‍♂️", text: "Private Gym" },
      { icon: "🍷", text: "Wine Cellar" },
      { icon: "🌴", text: "Rooftop Terrace" },
    ],
    price: "1,250,000",
    beds: "4",
    baths: "2",
    size: "200 m²",
    status: "For Sale",
    bgImage: bgImage2,
    ctabtn: "buy now",
  },

  {
    title: "The Alpine Nest",
    location: "Zermatt, Switzerland",
    description:
      "Tucked away in the serene peaks of Zermatt, The Alpine Nest is a luxurious 180m² mountain retreat offering uninterrupted views of the Swiss Alps. Designed in classic chalet style with modern touches, this four-bedroom hideaway features warm timber interiors, a cozy stone fireplace, and a private sauna for après-ski relaxation. Whether you're hitting the slopes or soaking in the alpine stillness, this property is your gateway to refined mountain living.",
    features: [
      { icon: "🏔️", text: "Panoramic Mountain Views" },
      { icon: "🔥", text: "Stone Fireplace" },
      { icon: "🧖‍♂️", text: "Private Sauna" },
      { icon: "🛷", text: "Nearby Ski Slopes" },
      { icon: "🌲", text: "Forest Surroundings" },
    ],
    price: "1,450,000",
    beds: "4",
    baths: "2",
    size: "180 m²",
    status: "For Sale",
    bgImage: bgImage3,
    ctabtn: "buy now",
  },

  {
    title: "Exclusive Beachfront Oasis",
    location: " Surfers Paradise,  Gold Coast, Australia",
    description:
      "Imagine stepping out of your front door and onto the golden sands of one of Australia's most iconic beaches. This exclusive 210m² residence offers uninterrupted, panoramic ocean views, combining luxury living with the serene sounds of the Pacific.Whether you're savoring sea breezes from the master suite or enjoying a morning surf just steps from your door, this home offers a rare blend of luxury, tranquility, and connection to nature.",
    features: [
      { icon: "🌊", text: "Ocean View" },
      { icon: "🏖️", text: "Private Beach Access" },
      { icon: "🏊‍♂️", text: "Infinity Pool" },
      { icon: "🧘‍♂️", text: "Gym & Spa" },
      { icon: "🍽️", text: "Modern Kitchen" },
    ],
    price: "1,749,000",
    beds: "3",
    baths: "3",
    size: "210 m²",
    status: "For Sale",
    bgImage: bgImage4,
    ctabtn: "buy now",
  },

  {
    title: "Stylish Urban Loft",
    location: " Chelsea, London",
    description:
      "You are waking up to the soft glow of London's skyline pouring through floor-to-ceiling industrial windows — this 210m² Chelsea loft blends timeless architectural charm with cutting-edge design and contemporary luxury. Exposed brick walls and steel beams nod to its historic warehouse roots, while bespoke finishes, high-end appliances, and sleek open-plan living create a seamless modern sanctuary in a fantastic very modern luxury environment",
    features: [
      { icon: "🌇", text: "Skyline View of Central London" },
      { icon: "🔒", text: "Private Entry & 24/7 Security" },
      { icon: "🛋️", text: "Designer-Furnished Interior" },
      { icon: "📍", text: "Prime Chelsea Location" },
      { icon: "🧱", text: "Exposed Brick & Steel Beams" },
    ],
    price: "3,576,000",
    beds: "3",
    baths: "3",
    size: "210 m²",
    status: "For Sale",
    bgImage: bgImage5,
    ctabtn: "buy now",
  },

  {
    title: "The Stillwater Home",
    location: "Irvine, California",
    description:
      "You are greeted by the golden California sun filtering through tall bay windows — this 210m² suburban retreat in the heart of Irvine California blends classic West Coast charm with modern, laid-back luxury. Crisp white facades, warm oak floors, and a spacious open-concept layout set the tone for relaxed elegance, while smart home features and designer finishes elevate everyday living lifestyle in a calm, sun-soaked residential setting.",
    features: [
      { icon: "🌳", text: "Spacious Backyard" },
      { icon: "🚗", text: "Two-Car Garage" },
      { icon: "🔥", text: "Indoor Fireplace" },
      { icon: "🎮", text: "Entertainment Room" },
      { icon: "🧺", text: "Laundry Room" },
    ],
    price: "1,749,000",
    beds: "3",
    baths: "3",
    size: "210 m²",
    status: "For Sale",
    bgImage: bgImage6,
    ctabtn: "buy now",
  },
];

const PropertiesSection = () => {
  return (
    <section className="properties-section">
      <motion.h1
        className="properties-main-title"
        initial={{ opacity: 0, y: 200 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true, amount: 0.5 }}
      >
        Luxury Living Starts Here
      </motion.h1>
      <div className="properties-grid">
        {PropertiesData.map((property, index) => (
          <PropertyCard key={index} {...property} />
        ))}
      </div>
    </section>
  );
};

export default PropertiesSection;
